$(document).ready(function () {
  var $container = $('.sets-container--linked-products');
  var $cards = $container.find('.sets-container__variants-checkbox');
  var $addToCartButton = $container.find('.add-to-cart--sets');

  $cards.on('click', 'a.sets-container__product-link', function (e) {
    var $card = $(this).closest('.sets-container__variants-checkbox');

    if ($card.hasClass('is-current-product')) {
      e.preventDefault();
      return false;
    }
  });

  $addToCartButton.on('click', function () {
    var $button = $(this);
    var $activeCard = $container.find('.sets-container__variants-checkbox.is-active');
    var $activeVariants = $activeCard.find('.variants p');
    var boxVariantId = $button.data('box-variant-id');
    var setTitle = $activeCard.find('.details > h3').first().text().trim();

    $container.find('.container-button .message-fail').hide();
    $container.find('.container-button .message-success').hide();

    if (!$activeVariants.length) {
      $container.find('.container-button .message-fail').css('display', 'flex');
      return;
    }

    var hasUnavailableVariant = false;

    $activeVariants.each(function () {
      var isAvailable = $(this).attr('data-available') === 'true';

      if (!isAvailable) {
        hasUnavailableVariant = true;
        return false;
      }
    });

    if (hasUnavailableVariant || $activeCard.hasClass('sets-container__variants-checkbox--sold-out')) {
      $container.find('.container-button .message-fail').css('display', 'flex');
      return;
    }

    var productosData = [];
    var randomSetId = generarDatoAleatorio();

    $activeVariants.each(function (index) {
      var variantId = $(this).attr('data-variant');
      var propertyLabel = 'Scent ' + (index + 1) + ' of 3';

      if (variantId) {
        productosData.push({
          id: variantId,
          quantity: 1,
          properties: {
            'SET': setTitle,
            'FRAGRANCE SELECTION': propertyLabel,
            'ID SET': randomSetId
          }
        });
      }
    });

    if (!productosData.length) {
      $container.find('.container-button .message-fail').css('display', 'flex');
      return;
    }

    if (boxVariantId) {
      productosData.push({
        id: boxVariantId,
        quantity: 1,
        properties: {
          'SET': setTitle,
          'FRAGRANCE SELECTION': 'Set Box',
          'ID SET': randomSetId
        }
      });
    }

    $('#load-btn-cart').addClass('is-loading');
    $button.css('pointer-events', 'none').css('opacity', '0.7');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: productosData },
      dataType: 'json',
      success: function () {
        $container.find('.container-button .message-success').css('display', 'flex');

        if (window.theme && typeof window.theme.updateCartCount === 'function') {
          window.theme.updateCartCount();
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      },
      error: function () {
        $container.find('.container-button .message-fail').css('display', 'flex');
      },
      complete: function () {
        $('#load-btn-cart').removeClass('is-loading');
        $button.css('pointer-events', '').css('opacity', '');
      }
    });
  });
});

function generarDatoAleatorio() {
  var letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var numeros = '0123456789';
  var resultado = '';

  for (var i = 0; i < 2; i++) {
    resultado += letras.charAt(Math.floor(Math.random() * letras.length));
  }

  for (var j = 0; j < 3; j++) {
    resultado += numeros.charAt(Math.floor(Math.random() * numeros.length));
  }

  resultado = resultado
    .split('')
    .sort(function () {
      return 0.5 - Math.random();
    })
    .join('');

  return resultado;
}